import { isWillChangeMotionValue } from './is.mjs';

function addValueToWillChange(visualElement, key) {
    if (!visualElement.applyWillChange)
        return;
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */
    if (isWillChangeMotionValue(willChange)) {
        return willChange.add(key);
    }
}

export { addValueToWillChange };
